'use client';

import { useCallback } from 'react';
import { toasterApi } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';
import { useTerminalApprovalStore } from '../../store/terminalApprovalStore';

export type AlwaysAllowRuleScope =
  | { scope: 'terminal'; pattern: string }
  | { scope: 'tool'; tool: string };

export function useAddAlwaysAllowRule(): (rule: AlwaysAllowRuleScope) => void {
  const tCopilot = useTranslations('chat.copilot');
  const addRule = useTerminalApprovalStore((state) => state.addRule);
  const addToolRule = useTerminalApprovalStore((state) => state.addToolRule);

  return useCallback(
    (rule: AlwaysAllowRuleScope) => {
      const added =
        rule.scope === 'terminal'
          ? addRule({ action: 'allow', pattern: rule.pattern })
          : addToolRule({ action: 'allow', tool: rule.tool });

      if (added) {
        toasterApi.success({
          title: tCopilot('terminalApproval.ruleAdded', {
            action: tCopilot('terminalApproval.actionAllow'),
            pattern: rule.scope === 'terminal' ? rule.pattern : rule.tool,
          }),
        });
      }
    },
    [addRule, addToolRule, tCopilot],
  );
}
